import { render } from "./PartnerModal.vue?vue&type=template&id=eeaf83b6&ts=true"
import script from "./PartnerModal.vue?vue&type=script&lang=ts"
export * from "./PartnerModal.vue?vue&type=script&lang=ts"

import "./PartnerModal.vue?vue&type=style&index=0&id=eeaf83b6&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__